"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _lightweightCharts = require("lightweight-charts");

var _reactFela = require("react-fela");

var _util = require("../../../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable consistent-return */

/**
 * The LightweightChart component renders a light version of trading view charts
 */
const LightweightChart = ({
  data = [],
  container,
  chartOptions,
  areaOptions,
  onPriceHover,
  isPositive = true,
  updatedData,
  visibleRange,
  onScroll
}) => {
  const seriesRef = (0, _react.useRef)(null);
  const chartRef = (0, _react.useRef)(null);
  const scrollRef = (0, _react.useRef)(null);
  const [isScrolling, setScrolling] = (0, _react.useState)(false);
  const fela = (0, _reactFela.useFela)();
  const theme = fela.theme;
  const getPrimaryChartColor = (0, _util.color)(theme, isPositive ? 'data.positive' : 'data.negative');
  const handleScrollingState = (0, _debounce.default)(value => {
    setScrolling(value);
  }, 200);

  const handleScroll = () => {
    var _seriesRef$current;

    setScrolling(true);
    (_seriesRef$current = seriesRef.current) === null || _seriesRef$current === void 0 ? void 0 : _seriesRef$current.applyOptions({
      color: (0, _util.color)(theme, 'interactive.primary.hover')
    });

    if (onScroll) {
      var _chartRef$current;

      const logicalRange = (_chartRef$current = chartRef.current) === null || _chartRef$current === void 0 ? void 0 : _chartRef$current.timeScale().getVisibleLogicalRange();

      if (logicalRange) {
        var _seriesRef$current2;

        const barsInfo = (_seriesRef$current2 = seriesRef.current) === null || _seriesRef$current2 === void 0 ? void 0 : _seriesRef$current2.barsInLogicalRange(logicalRange);
        onScroll(barsInfo !== null && barsInfo !== void 0 ? barsInfo : null);
      }
    }

    handleScrollingState(false);
  };

  const handleCrosshairMove = series => params => {
    if (!params || !params.time || !params.point || params.point.x < 0 || params.point.y < 0) {
      if (onPriceHover && data[data.length - 1]) {
        onPriceHover({
          price: "".concat(data[data.length - 1].value),
          time: params.time
        });
      }

      return;
    }

    const price = params.seriesPrices.get(series);

    if (onPriceHover) {
      var _price$toString;

      onPriceHover({
        price: (_price$toString = price === null || price === void 0 ? void 0 : price.toString()) !== null && _price$toString !== void 0 ? _price$toString : '',
        time: params.time
      });
    }
  };

  (0, _react.useEffect)(() => {
    if (!isScrolling) {
      var _seriesRef$current3;

      (_seriesRef$current3 = seriesRef.current) === null || _seriesRef$current3 === void 0 ? void 0 : _seriesRef$current3.applyOptions({
        color: getPrimaryChartColor
      });
    }
  }, [isScrolling, isPositive]);
  (0, _react.useEffect)(() => {
    if (!container.current) return;
    const chart = (0, _lightweightCharts.createChart)(container.current, chartOptions);
    const areaSeries = chart.addLineSeries({
      color: getPrimaryChartColor,
      ...areaOptions
    });
    seriesRef.current = areaSeries;
    chartRef.current = chart;
    areaSeries.setData(data);
    chart.subscribeCrosshairMove(handleCrosshairMove(areaSeries));
    chart === null || chart === void 0 ? void 0 : chart.timeScale().subscribeVisibleLogicalRangeChange(handleScroll);
    scrollRef.current = handleScroll;
    return () => {
      chart.unsubscribeCrosshairMove(handleCrosshairMove(areaSeries));
      chart === null || chart === void 0 ? void 0 : chart.timeScale().unsubscribeVisibleLogicalRangeChange(scrollRef.current || handleScroll);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (data.length > 0) {
      var _seriesRef$current4, _chartRef$current2, _chartRef$current3;

      (_seriesRef$current4 = seriesRef.current) === null || _seriesRef$current4 === void 0 ? void 0 : _seriesRef$current4.setData(data);
      (_chartRef$current2 = chartRef.current) === null || _chartRef$current2 === void 0 ? void 0 : _chartRef$current2.timeScale().setVisibleLogicalRange(visibleRange);
      (_chartRef$current3 = chartRef.current) === null || _chartRef$current3 === void 0 ? void 0 : _chartRef$current3.timeScale().setVisibleRange(visibleRange);
    }
  }, [data, visibleRange]);
  (0, _react.useEffect)(() => {
    if (updatedData) {
      var _seriesRef$current5;

      (_seriesRef$current5 = seriesRef.current) === null || _seriesRef$current5 === void 0 ? void 0 : _seriesRef$current5.update(updatedData);
    }
  }, [updatedData]);
  (0, _react.useEffect)(() => {
    var _chartRef$current5;

    if (scrollRef.current) {
      var _chartRef$current4;

      (_chartRef$current4 = chartRef.current) === null || _chartRef$current4 === void 0 ? void 0 : _chartRef$current4.timeScale().unsubscribeVisibleLogicalRangeChange(scrollRef.current);
    }

    (_chartRef$current5 = chartRef.current) === null || _chartRef$current5 === void 0 ? void 0 : _chartRef$current5.timeScale().subscribeVisibleLogicalRangeChange(handleScroll);
    scrollRef.current = handleScroll;
  }, [onScroll]);
  return null;
};

LightweightChart.displayName = 'LightweightChart';
var _default = LightweightChart;
exports.default = _default;
//# sourceMappingURL=LightweightChart.js.map